// LOGIN USER Constants
export const SET_LOGIN_USER_REQUEST = 'SET_LOGIN_USER_REQUEST';
export const SET_LOGIN_USER_SUCCESS = 'SET_LOGIN_USER_SUCCESS';
export const SET_LOGIN_USER_ERROR = 'SET_LOGIN_USER_ERROR';
export const SET_TOKEN="SET_TOKEN";